module.exports = __webpack_public_path__ + "img/ic-arrow-drop-down.2bfb9e59.svg";